import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {GlobalSearchService} from '../../../../core/services/global-search.service';
import {Project, Service, ServiceOrder} from '@app/shared';
import {Subject, takeUntil} from 'rxjs';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-global-search-results',
  standalone: false,

  templateUrl: './global-search-results.component.html',
  styleUrl: './global-search-results.component.less'
})
export class GlobalSearchResultsComponent implements OnInit, OnDestroy {

  @Input() isSmallMode: boolean = false;

  @Input() showProjects: boolean = true;
  @Input() showServices: boolean = true;
  @Input() showServiceOrders: boolean = true;

  searchvalue: string = '';

  projects: Project[] = [];
  thereIsMoreProjectsToShown: boolean = false;
  services: Service[] = [];
  thereIsMoreServicesToShown: boolean = false;
  serviceOrders: ServiceOrder[] = [];
  thereIsMoreServiceOrdersToShown: boolean = false;

  isEmptyResult: boolean = false;

  entity: string = '';
  protected readonly environment = environment;
  private destroy$ = new Subject<void>();

  constructor(
    private globalSearchService: GlobalSearchService
  ) {
  }

  ngOnInit(): void {
    this.globalSearchService.globalSearchResult
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (value) {
          const rowsToTake = this.isSmallMode ? 4 : undefined;

          this.projects = (value.data.projects.rows || []).slice(0, rowsToTake);
          this.thereIsMoreProjectsToShown = value.data.projects.lastRow > 4;

          this.services = (value.data.services.rows || []).slice(0, rowsToTake);
          this.thereIsMoreServicesToShown = value.data.services.lastRow > 4;

          this.serviceOrders = (value.data.serviceOrders.rows || []).slice(0, rowsToTake);
          this.thereIsMoreServiceOrdersToShown = value.data.serviceOrders.lastRow > 4;
        }

        this.isEmptyResult = this.projects.length === 0 && this.services.length === 0 && this.serviceOrders.length === 0;
      });

    this.globalSearchService.globalSearchValue
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.searchvalue = value;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  needToShowEmptyState(): boolean {
    const showAll = this.showProjects && this.showServices && this.showServiceOrders;
    if (showAll) return false;

    this.entity = this.showProjects ? 'Proyectos' : this.showServices ? 'Servicios' : 'Órdenes de servicio';

    return (this.projects.length === 0 && this.showProjects)
      || (this.services.length === 0 && this.showServices)
      || (this.serviceOrders.length === 0 && this.showServiceOrders);
  }
}
